import { render, staticRenderFns } from "./PlantillasList.vue?vue&type=template&id=12c069ec&scoped=true&"
import script from "./PlantillasList.vue?vue&type=script&lang=js&"
export * from "./PlantillasList.vue?vue&type=script&lang=js&"
import style0 from "./PlantillasList.vue?vue&type=style&index=0&id=12c069ec&lang=scss&scoped=true&"
import style1 from "./PlantillasList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PlantillasList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c069ec",
  null
  
)

export default component.exports